import {Component, OnInit} from '@angular/core';
import {UsuarioService} from 'src/app/services/usuario.service';
import {Usuario} from 'src/app/model/usuario.model';
import {AgendamentoService} from 'src/app/services/agendamento.service';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';
import {Agendamento} from 'src/app/model/agendamento.model';
import {first} from 'rxjs/operators';
import {Result} from 'src/app/model/result.model';
import {Router} from '@angular/router';
import {Servico} from 'src/app/model/servico.model';
import {ServicoService} from 'src/app/services/servico.service';
import {Agencia} from 'src/app/model/agencia.model';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfigurationService} from 'src/app/services/configuration.service';
import {LogData} from '../../model/logData.model';
import {PendingData} from '../../model/pendingData.model';
import {CustomSiteService} from '../../services/customsite.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

    usuario: Usuario;
    listaTemp: Agendamento[];
    agendamentos: Agendamento[];
    showSpinner = false;
    servico: Servico;
    servicos: Servico[];
    agencias: Agencia[];
    agenciaSelecionada: Number;
    closeResult: string;
    protocolPage = 0;
    hasMoreProtocols = false;
    pageTitle = "Atendimento - Pagmob";

    constructor(private modalService: NgbModal, private configurationService: ConfigurationService, private router: Router, private usuarioService: UsuarioService, private agendamentoService: AgendamentoService, private servicoService: ServicoService, public googleAnalyticsService: GoogleAnalyticsService, private customSiteService: CustomSiteService) { }

    ngOnInit() {
        this.listaTemp = [];
        this.googleAnalyticsService.eventEmitter("dashboard", "load", "page-load", 1);
        localStorage.removeItem('dadosIniciaisAgendamento');
        localStorage.removeItem('dadosPagamento');
        this.usuario = this.usuarioService.getDadosUsuario();
        const agenciaSelecionada = JSON.parse(localStorage.getItem("agenciaSelecionada"));
        let config = this.configurationService.loadConfigurations()
        config.subscribe(result => {
            this.agenciaSelecionada = result.agencyId;
            this.getProtocols();
          const pageTitle = sessionStorage.getItem("pageTitle");
          if(pageTitle == null)
              this.customSiteService.login(agenciaSelecionada).subscribe(customsite => {
                if(customsite.pageTitle) {
                  this.pageTitle = customsite.pageTitle;
                  sessionStorage.setItem("pageTitle",this.pageTitle);
                }
                if(customsite.pageTitle) sessionStorage.setItem("loginText", customsite.loginText);
                if(customsite.loginObs) sessionStorage.setItem("loginObs", customsite.loginObs);
                if(customsite.popUp) sessionStorage.setItem("popUp", customsite.popUp);
                if(customsite.privacy) sessionStorage.setItem("privacy", customsite.privacy);
                if(customsite.termsAcceptance) sessionStorage.setItem("termsAcceptance", customsite.termsAcceptance);
                if(customsite.register) sessionStorage.setItem("register", customsite.register);
              });
          else {
            this.pageTitle = pageTitle;
          }
        });
    }

    getProtocols() {
        this.showSpinner = true;
        this.agendamentoService.getProtocols(this.agenciaSelecionada,this.protocolPage++).pipe(first()).subscribe((result: Agendamento[]) => {
          this.showSpinner = false;
          this.agendamentos = result;
          this.hasMoreProtocols = result.length >= 3;
          sessionStorage.setItem("agendamentos",JSON.stringify(this.agendamentos.filter(a => a.statusType != 'CLOSED' && a.statusType != 'CANCELED')));
          this.agendamentos.filter(a => a.statusType == "INVALID_DATA").forEach(a => this.getPending(a.protocol));
        }, (err) => { this.showSpinner = false; });
    }

    getMoreProtocols() {
      this.showSpinner = true;
      this.agendamentoService.getProtocols(this.agenciaSelecionada,this.protocolPage++).pipe(first()).subscribe((result: Agendamento[]) => {
        this.showSpinner = false;
        result.forEach(r => this.agendamentos.push(r));
        this.hasMoreProtocols = result.length >= 3;
        sessionStorage.setItem("agendamentos",JSON.stringify(this.agendamentos.filter(a => a.statusType != 'CLOSED' && a.statusType != 'CANCELED')));
        this.agendamentos.filter(a => a.statusType == "INVALID_DATA").forEach(a => this.getPending(a.protocol));
      }, (err) => { this.showSpinner = false; });
    }

    getPending(protocol) {
      this.agendamentoService.getPending(protocol).pipe(first()).subscribe((result: PendingData[]) => {
        this.agendamentos.filter(a => a.protocol == protocol).forEach(a => a.pendingDataList = result);
      });
    }

    cancelaAgendamento(protocolo) {
        this.showSpinner = true;
        this.googleAnalyticsService.eventEmitter("dashboard", "button-click", "cancelamento", 2);
        this.agendamentoService.deleteCancelaAgendamento(this.agenciaSelecionada, protocolo).pipe(first()).subscribe((result: Result) => {
            this.googleAnalyticsService.eventEmitter("dashboard", "button-click", "sucesso", 3);
            this.showSpinner = false;
            this.getProtocols();
        }, (err) => { this.googleAnalyticsService.eventEmitter("dashboard", "button-click", "erro", 4); this.showSpinner = false; });
    }

    editAgendamento(agendamento) {
        this.showSpinner = true;
        agendamento.agencyId = this.agenciaSelecionada;

        this.servicoService.getServicos(this.agenciaSelecionada, agendamento.serviceTypeVO.id, this.usuario.empresa).subscribe((result: Servico[]) => {
            this.showSpinner = false;
            this.servicos = result;
            if(this.servicos != null) {
                for (let i = 0; i < this.servicos.length; i++) {
                    if (this.servicos[i].id == agendamento.serviceId) this.servico = this.servicos[i];
                }
                if(this.servico == undefined) this.servico = new Servico();
              const model = { 'agenciaId': agendamento.agencyId, 'servico': this.servico, 'agendamento': agendamento };
                localStorage.setItem('dadosIniciaisAgendamento', JSON.stringify(model));
                this.router.navigate(['/app/agendamento/edit']);
            } else {
                this.servico = new Servico();
            }
        }, () => { this.showSpinner = false; });
    }

    pagarAgendamento(agendamento) {
        this.showSpinner = true;
        const model = { 'agenciaId': this.agenciaSelecionada, 'agendamento': agendamento };
        localStorage.setItem('dadosPagamento', JSON.stringify(model));
        this.router.navigate(['/app/pagamento']);
    }

    open(protocol,content) {
      this.showSpinner = true;
        this.agendamentoService.getLog(protocol).pipe(first()).subscribe((l : LogData[]) => {
          this.showSpinner = false;
          this.agendamentos.filter(a => a.protocol == protocol).forEach(a => {
            a.logDataList = l;
            a.attendanceAnswer = l.filter(log => log.text).sort((a,b) => new Date(a.ts).getUTCMilliseconds() - new Date(b.ts).getUTCMilliseconds())[0].text;
          });
          this.modalService.open(content, {ariaLabelledBy: 'modalInfoLabel'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
          }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          });
        });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return  `with: ${reason}`;
        }
    }
}
